export const toastConstants = {
	START_CLOSING: 'START_CLOSING',
	CLOSE: 'CLOSE',
	DANGER: 'DANGER',
	SUCCESS: 'SUCCESS',
	WARNING: 'WARNING'
}
